import { render, staticRenderFns } from "./PlanChangeModal.vue?vue&type=template&id=760c7755&lang=pug"
import script from "./PlanChangeModal.vue?vue&type=script&lang=ts"
export * from "./PlanChangeModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports